import React from 'react';
import { Heart, Instagram, Facebook, Twitter, Mail, MapPin, Phone } from 'lucide-react';
import { NAV_LINKS, CONTACT } from '../data/mock';

const Footer = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0B3B44] text-white pt-16 pb-8 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-[#EC407A] via-[#F55B26] via-[#FFB347] via-[#7CB342] via-[#2196F3] to-[#8E24AA]" />
      <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-[#F55B26]/10 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="bg-white rounded-2xl p-2 shadow-md">
                <img
                  src="/assets/logo.jpg"
                  alt="Hello Foundation — Baytul Hafiza"
                  className="h-12 w-auto block"
                />
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              A South African registered NPO providing meals, dignity, and mental wellness support to underserved communities since 2020.
            </p>
            <div className="flex gap-3 pt-2">
              {[
                { Icon: Instagram, href: 'https://www.instagram.com/hello_fund/' },
                { Icon: Facebook, href: '#' },
                { Icon: Twitter, href: '#' },
              ].map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-white/10 border border-white/15 flex items-center justify-center hover:bg-[#F55B26] hover:border-[#F55B26] transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="font-bold text-sm uppercase tracking-widest mb-4 text-[#FFB347]">Navigate</div>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.label}>
                  <button
                    onClick={() => scrollTo(l.href)}
                    className="text-sm text-white/75 hover:text-white transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-bold text-sm uppercase tracking-widest mb-4 text-[#FFB347]">Initiatives</div>
            <ul className="space-y-2">
              <li className="text-sm text-white/75">Fighting Hunger</li>
              <li className="text-sm text-white/75">Fighting Poverty</li>
              <li className="text-sm text-white/75">Community Feeding</li>
              <li>
                <a
                  href="https://www.hellosupport.co.za"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-[#FFB347] hover:text-white font-semibold transition-colors"
                >
                  Hello Support (2027) →
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-bold text-sm uppercase tracking-widest mb-4 text-[#FFB347]">Contact</div>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-white/75">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#F55B26]" />
                <span>{CONTACT.address}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/75">
                <Mail className="w-4 h-4 flex-shrink-0 text-[#F55B26]" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-white">{CONTACT.email}</a>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/75">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#F55B26]" />
                <a href={`tel:${CONTACT.phone}`} className="hover:text-white">{CONTACT.phone}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-sm text-white/60">
          <div>
            &copy; {new Date().getFullYear()} Hello Foundation. All rights reserved. NPO Registered in South Africa.
          </div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
